import { render, staticRenderFns } from "./ModalPurchaseAccount.vue?vue&type=template&id=0bc73744&"
import script from "./ModalPurchaseAccount.vue?vue&type=script&lang=js&"
export * from "./ModalPurchaseAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports